module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(" here is an h1 ")]), _vm._v(" "), _c('h2', [_vm._v(" here is an h2 ")]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_vm._v("here is a large paragraph")]), _vm._v(" "), _c('p', [_vm._v("here is a regular paragraph")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-504f0e60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/sandbox.vue
// module id = 623
// module chunks = 1